<script setup>
import { computed, inject, ref } from 'vue';

const currentStep = computed(() => inject('currentStep') || 1);

const isFinalized = ref(false);

const steps = computed(() => [
  { label: 'step1', number: 1 },
  { label: 'step2', number: 2 },
  { label: 'step3', number: 3 },
  { label: 'step4', number: 4 },
  { label: 'step5', number: 5 },
]);
</script>

<template>
  <div class="wizard-container">
    <div class="flex">
      <div class="flex-container wizard_progress_bar col-1 mr-4">
        <div class="progress">
          <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="60" class="progress-bar" role="progressbar"></div>
        </div>
        <div
          v-for="(step, i) in steps"
          :key="i"
          :class="{ done: step.number < currentStep, current: step.number === currentStep }"
          class="step"
        >
          <div :id="'step-' + step.number" class="step-number">
            <i v-if="step.number < currentStep" class="fa fa-check"></i>
            <span v-else>{{ step.number }}</span>
          </div>
        </div>
      </div>

      <div :class="!isFinalized ? 'col-10' : 'col-12'" class="col-10 wizard-step-container">
        <slot />
        <div class="grid-2 mt-2 relative z-10">
          <div class="form_row end start">
            <slot name="actions" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.wizard-container {
  margin: 30px 50px;
  border-radius: 20px;
  background-color: white;
}

/* vue-stepper styling */
.flex-container {
  display: grid;
  flex-direction: row;
  justify-content: space-between;
  padding: 1em;
  height: 750px;
  align-items: center;

  .progress {
    position: absolute;
    top: 6em;
    width: 70px;
    margin: 0;
    box-shadow: none;
    overflow: visible;
    background: none;

    .progress-bar {
      display: block;
      margin: 0 auto;
      background-color: var(--bg-primary);
      width: 5px;
      transition: all 0.4s 0.5s;
    }
  }

  .step {
    z-index: 2;
    width: 40px;
    height: 40px;
    background-color: #dfeff4;
    border-radius: 2em;
    display: flex;
    align-items: center;
    justify-content: center;

    .step-number {
      color: var(--light);
      font-weight: 600;
      font-size: 1.2em;
      line-height: 1;
    }

    &.current {
      background-color: var(--bg-primary);
      transition: all 0.4s 0.5s;
    }

    &.done {
      background-color: var(--bg-primary);
    }

    .step-label {
      padding-top: 5px;
    }
  }
}

.wizard-step-container {
  padding: 70px 0;
}
</style>
